// export.ts — CSV export of a child's size records + inventory (all local; nothing
// leaves the device). Built client-side.

import type { Child, SizeRecord, InventoryItem } from "./store";

function cell(v: string | number | null | undefined): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** One combined CSV with a Kind column so size records and inventory can share a file. */
export function buildExport(
  child: Child,
  records: SizeRecord[],
  inventory: InventoryItem[],
): { csv: string; filename: string } {
  const rows: (string | number | null | undefined)[][] = [];
  for (const r of records) {
    rows.push(["size", r.recorded_on, r.category, r.size_label, r.size_value ?? "", r.brand, r.note, "", ""]);
  }
  for (const i of inventory) {
    rows.push(["inventory", i.bought_on, i.category, i.size_label, i.size_value ?? "", "", i.note, i.description, i.for_season]);
  }
  const out = csv(
    ["Kind", "Date", "Category", "Size", "Size value", "Brand", "Note", "Description", "For season"],
    rows,
  );
  const stamp = new Date().toISOString().slice(0, 10);
  const safeName = child.name.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "child";
  return { csv: out, filename: `outgrown-${safeName}-${stamp}.csv` };
}
